import { defineStore } from 'pinia'
import axios from "@/app/plugins/Axios";

import listasApi from '@/app/services/listas';

export const useContasBancariasStore = defineStore('contasbancarias', {

  state: () => ({
    contas_bancarias: [],
  }),

  actions: {

    async listarContasBancarias(fornecedor_id = null) {

      const response = await axios.get(`fornecedor/${fornecedor_id}/contas`);
      this.contas_bancarias = response.data;
    },

    limparContasBancarias() {
      this.contas_bancarias = [];
    }

  },

})


